import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import _ from 'lodash'
import NumberFormat from 'react-number-format'

const header = ['Start Date', 'Pay Grade Name', 'Salary']

export default class TableConfidentialHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.checkCode = this.checkCode.bind(this)
  }
  handleClickRow(e, edit_id, id) {
    this.props.handleClickShowInformation(id)
    this.setState({ id: edit_id })
  }
  checkCode(code) {
    if (_.get(this.props, 'emp_code') !== undefined) {
      return _.get(this.props, 'emp_code') === code.emp_code
    }
    return _.get(this.props, 'emp_code') !== code.emp_code
  }

  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <div>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                header.map((h, key) =>
                  <HeadHis>{ h }</HeadHis>
                )}
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: '130px', overflowY: 'scroll' } }>
            {
              _.get(this.props, 'confidential_group.length') !== 0 &&
              _.get(this.props, 'confidential_group.length') !== undefined &&
          _.get(this.props, 'confidential_group').filter(this.checkCode).map((d, key) =>

            (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && _.get(this.props, 'span')) ? '#E5E5E5' : '' } } onClick={ () => this.handleClickRow(this, key, d._id) }>
              <td>{ d.start_date ? moment(d.start_date).format('YYYY-MM-DD') : '' }</td>
              <td>{ d.level }</td>
              <td style={ { textAlign: 'right' } }>
                {
                  <NumberFormat
                    thousandSeparator={ true }
                    decimalScale={ 2 }
                    fixedDecimalScale={ true }
                    displayType='text'
                    value={ d.salary }
                  />
                }
              </td>
            </tr>)
          )}

          </tbody>
        </NewTable>
      </div>
    )
  }
}

TableConfidentialHistory.propTypes = {
  handleClickShowInformation: PropTypes.func.isRequired,
}

const NewTable = styled(Table)`
    background: white;
    thead, tbody tr{
      display:table;
      width:100%;
      table-layout:fixed;
      font-family: 'Gotham' !important;
      font-weight: lighter !important;
    }
`
const HeadHis = styled.th`
    color: white;
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    cursor: pointer;
`
const Header = styled.thead`
    background: black;
    color: white;
`



// WEBPACK FOOTER //
// ./src/components/table-confidential-history/index.js